var _style, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2001D;}\n\t.st1{fill:#F0F0F0;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M437,437C337,537,175,537,75,437C-25,337-25,175,75,75C175-25,321.3-9.3,421.3,90.7C521.3,190.7,537,337,437,437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,75C175-25,337-25,437,75c100,100,100,262.1,0,362"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,345l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.8-7.9h13.4L195.6,345z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.4,222.6l6.9,21.3h22.4L172.6,257l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.4L161.4,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.4,378.4l6.9,21.3h22.4l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.3L161.4,378.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,278.3l6.9,21.3H256l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.4L226.7,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,278.3l6.9,21.3h22.3l-18.1,13.1l6.9,21.3L96,320.8L78,333.9l6.9-21.3l-18.1-13.1h22.4L96,278.3z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.5,189.6c-11.4-11.4-26.3-18.2-42.3-19.4l47.8-37.2c-19-19-44.6-27.6-69.5-25.8c-3-10.7-8.7-20.8-17.1-29.3 l-18.9,37.8c-1.2-2.3-2.8-4.4-4.7-6.3c-10.9-10.9-28.5-10.9-39.4,0s-10.9,28.5,0,39.4c1.9,1.9,4,3.5,6.3,4.7l-37.8,18.9 c8.4,8.4,18.6,14.1,29.3,17.1c-1.8,24.9,6.8,50.4,25.8,69.5l41.8-53.7c3.1-3.1,7.3-4.8,11.7-4.8c4.5,0,8.7,1.7,11.8,4.9 c3.2,3.2,4.9,7.3,4.9,11.8c0,4.5-1.7,8.7-4.9,11.8l15.7,15.7c7.4-7.4,11.4-17.1,11.4-27.5c0-8.5-2.7-16.6-7.7-23.3 c7.3,2,14.2,5.8,19.9,11.5c17.4,17.4,17.4,45.6,0,63l15.7,15.7c12.6-12.6,19.6-29.4,19.6-47.2C448.1,218.9,441.2,202.2,428.5,189.6 L428.5,189.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/pg.1ce5b4b151b3ceeb68c8d786d0301b09.svg";
export { ForwardRef as ReactComponent };